import React from 'react';
import { Button } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '../../../i18n';
import style from '../feature.module.less';

interface IResetProps {
    onClick?: Function;
    customStyle?: React.CSSProperties;
}

const Reset: React.FC<IResetProps> = ({ onClick, customStyle }) => {
    const { $t } = useLocaleStore();
    return (
        <div className={style.item} style={customStyle}>
            <Button
                className={style.button}
                onClick={() => {
                    onClick?.();
                }}
                block
                icon={<IconFont name="RefreshBold" fontSize={16} />}
            >
                {$t((v) => v.mainLayer.intelligent.reset)}
            </Button>
        </div>
    );
};

export default React.memo(Reset);
